/* eslint-disable linebreak-style */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable quote-props */
/* eslint-disable comma-dangle */
import React, { Component } from 'react';
import { Helmet } from 'react-helmet-async';

import Header from 'parts/Header';
import BlogList from 'parts/BlogList';
import Footer from 'parts/Footer';
import Seo from 'parts/Seo';

import { BlogArticles } from 'json/blogData';

export default class BlogPage extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    // Generate ItemList schema for SEO
    const itemListSchema = {
      "@context": "https://schema.org",
      "@type": "ItemList",
      "name": "Artikel Blog Teknisi CNC",
      "description": "Kumpulan artikel informatif tentang mesin CNC, perawatan, troubleshooting, dan teknologi manufaktur",
      "numberOfItems": BlogArticles.length,
      "itemListElement": BlogArticles.slice(0, 10).map((article, index) => ({
        "@type": "ListItem",
        "position": index + 1,
        "item": {
          "@type": "Article",
          "@id": `https://teknisi.space/blog/${article.id}`,
          "name": article.title,
          "description": article.summary,
          "image": article.imageUrl,
          "author": {
            "@type": "Person",
            "name": article.author
          }
        }
      }))
    };

    const breadcrumbSchema = {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": [
        {
          "@type": "ListItem",
          "position": 1,
          "name": "Beranda",
          "item": "https://teknisi.space/"
        },
        {
          "@type": "ListItem",
          "position": 2,
          "name": "Blog",
          "item": "https://teknisi.space/blog"
        }
      ]
    };

    return (
      <>
        <Seo
          title="Blog Teknisi CNC - Artikel & Tips Perawatan Mesin CNC"
          description="Kumpulan artikel informatif dari teknisi CNC berpengalaman tentang perawatan mesin CNC, tips operasional, troubleshooting, teknologi terbaru industri manufaktur, panduan pemilihan mesin, retrofit CNC, dan tutorial teknis lainnya."
          keywords="blog teknisi cnc, artikel mesin cnc, tips perawatan cnc, panduan cnc, teknologi cnc terbaru, troubleshooting cnc, tutorial cnc, tips teknisi cnc, retrofit cnc, service mesin cnc, maintenance cnc, panduan operator cnc"
          canonicalUrl="https://teknisi.space/blog"
        />
        <Helmet>
          <script type="application/ld+json">
            {JSON.stringify(itemListSchema)}
          </script>
          <script type="application/ld+json">
            {JSON.stringify(breadcrumbSchema)}
          </script>
        </Helmet>
        <Header />
        <div className="h-10" />
        <BlogList data={BlogArticles} />
        <Footer />
      </>
    );
  }
}
